import { Card } from '@skooldio/skooldio-ui-components-core';

export default Card;
